import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { Segment } from "semantic-ui-react";
import { PublicHomeNav } from "../../Common/PublicComponents/PublicHomeNav";
import { PublicSkipContentLink } from "../../Common/PublicComponents/PublicSkipContentLink";
import { PUBLIC_SITE_URL_ACTIVE_MAP } from "../../../App";
import { getPageContent } from "../../../Services/PublicServices";
import { SectionData } from "../ManageHomepageSections/SectionCard";
import { unset } from "lodash";

export function PublicCustomPages() {
  let { urlcode } = useParams<{ urlcode: string }>();
  const htmlHeaders = `<!DOCTYPE html><html lang="en">`;
  const htmlAfters = `</html>`;
  useEffect(() => {
    setIsLoading(true);
    getPageContent(urlcode, false)
      .then((response) => {
        setIsLoading(false);
        if (response && response.data) {
          let newData = response.data as SectionData;
          setSectionData(newData);
        } else {
          throw new Error("Unable to get data from server.");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const [sectionData, setSectionData] = useState<SectionData | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const dataLoaded: boolean = sectionData !== null;

  const pageHTML =
    htmlHeaders +
    (sectionData != null ? sectionData.pageContent : "") +
    htmlAfters;

  return (
    <>
      <div className="wrapper">
        <PublicSkipContentLink />
        <PublicHomeNav publicSiteURLActiveMap={PUBLIC_SITE_URL_ACTIVE_MAP} />
        <div className="main" id="content">
          <section className="section section-features section-offset">
            <header className="section__head">
              <div className="shell">
                <div className="section__head-inner">
                  <h1>{(sectionData && sectionData.title) || ""}</h1>

                  <nav className="breadcrumbs section__breadcrumbs">
                    <ul>
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li
                        className="is-current"
                        style={{ marginLeft: "0.5rem" }}
                      >
                        {(sectionData && sectionData.title) || ""}
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </header>

            <div className="section__body">
              <div className="shell">
                <div
                  className="section__body-inner"
                  style={{ maxWidth: "unset" }}
                >
                  {!dataLoaded && (
                    <Segment loading style={{ minHeight: "20rem" }}></Segment>
                  )}
                  {
                    dataLoaded && (
                      <div id="page_content">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: (sectionData || {}).pageContent || "",
                          }}
                        ></div>
                      </div>
                    )
                    // <iframe id='iframe-render-container' style={{minHeight:'100vh', width:'100%', overflow:'auto'}}
                    //     srcDoc={pageHTML}
                    //     sandbox = "allow-same-origin"
                    //     title = ''
                    //     onLoad= {(o)=>{
                    //         let iframe = window.document.getElementById('iframe-render-container');
                    //         // @ts-expect-error
                    //         iframe.height = iframe.contentWindow.document.body.scrollHeight + 50;
                    //         //console.log(iframe.contentWindow);
                    //     }}
                    // />
                  }
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
